import ContentServices from "../../services/ContentServices";
import { Router } from "preact-router";
import { getTrendingEvents } from "./trendingActions";

export const GET_LOCALE_REQUEST = "GET_LOCALE_REQUEST";
export const GET_LOCALE_SUCCESS = "GET_LOCALE_SUCCESS";
export const GET_LOCALE_ERROR = "GET_LOCALE_ERROR";

export const GET_CONTENT_REQUEST = "GET_CONTENT_REQUEST";
export const GET_CONTENT_SUCCESS = "GET_CONTENT_SUCCESS";
export const GET_CONTENT_ERROR = "GET_CONTENT_ERROR";

const localeData = {
  au: {
    country: "Australia",
    infoEmail: "info@humanitix.com.au",
    eventEmail: "events@humanitix.com.au",
    nfpEmail: "nfp@humanitix.com.au",
    charitiesEmail: "charities@humanitix.com.au",
    earlyPaymentsEmail: "earlypayment@humanitix.com",
    accountsEmail: "accounts@humanitix.com",
    contactNumber: "0299862635",
    consoleURL: "https://console.humanitix.net",
    ticketURL: "https://events.humanitix.com.au"
  },
  nz: {
    country: "New Zealand",
    infoEmail: "info@humanitix.co.nz",
    eventEmail: "events@humanitix.co.nz",
    nfpEmail: "nfp@humanitix.co.nz",
    charitiesEmail: "charities@humanitix.co.nz",
    earlyPaymentsEmail: "earlypayment@humanitix.co.nz",
    accountsEmail: "accounts@humanitix.co.nz",
    contactNumber: "0273438881",
    consoleURL: "https://console.humanitix.co.nz",
    ticketURL: "https://events.humanitix.co.nz"
  }
};

export const getLocale = () => {
  return dispatch => {
    dispatch({ type: GET_LOCALE_REQUEST });
    ContentServices.getCountry()
      .then(res => {
        dispatch({
          type: GET_LOCALE_SUCCESS,
          locale: res,
          localeData: localeData[res]
        });
      })
      .catch(err => {
        dispatch({ type: GET_LOCALE_ERROR, locale: "AU" });
      });
  };
};

export const changeLocale = locale => {
  return dispatch => {
    dispatch({
      type: GET_LOCALE_SUCCESS,
      locale: locale,
      localeData: localeData[locale]
    });
    dispatch(getTrendingEvents(locale));
    const currentUrl = Router.getCurrentUrl();
    ContentServices.getUrl(currentUrl, locale).then(newUrl => {
      Router.route(newUrl);
    });
  };
};

export const initLocale = locale => {
  return dispatch => {
    dispatch({
      type: GET_LOCALE_SUCCESS,
      locale: locale,
      localeData: localeData[locale]
    });
  };
};

export const getContent = (contentString, locale) => {
  return dispatch => {
    dispatch({ type: GET_CONTENT_REQUEST, key: contentString });
    ContentServices.getComponentContent(contentString, locale)
      .then(res => {
        dispatch({
          type: GET_CONTENT_SUCCESS,
          key: contentString,
          data: res.data
        });
      })
      .catch(err => {
        dispatch({ type: GET_CONTENT_ERROR, key: contentString });
      });
  };
};
